module.exports = __webpack_public_path__ + "static/media/julien.a84c2e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/julien.png
// module id = 506
// module chunks = 0